import React from 'react';
import { compose } from 'redux';
import { useTranslation } from 'react-i18next';
import SearchIcon from '@wix/da-ds/pkg/Icons/24x24/Search';
import withSearch from '../../_hocs/withSearch';
import Flex from '@wix/da-ds/pkg/Flex';
import noSearchResultStyles from './NoSearchResults.scss';
const enhance = compose(withSearch);
export const NoSearchResults = ({ unsetSearchQuery, unsetSearchInput })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(Flex, {
        fullWidth: true,
        fullHeight: true,
        direction: "column",
        justifyContent: "center",
        alignItems: "center"
    }, /*#__PURE__*/ React.createElement(SearchIcon, {
        className: noSearchResultStyles['icon']
    }), /*#__PURE__*/ React.createElement("div", {
        className: noSearchResultStyles['no-results']
    }, t('mediapopup.search.noResultsFound')), /*#__PURE__*/ React.createElement("div", {
        className: noSearchResultStyles['go-back-to']
    }, t('mediapopup.search.goBackTo'), /*#__PURE__*/ React.createElement("button", {
        className: noSearchResultStyles['all-artworks-button'],
        onClick: ()=>{
            unsetSearchQuery();
            unsetSearchInput();
        }
    }, t('mediapopup.allArtworks'))));
};
NoSearchResults.displayName = 'NoSearchResults';
export default enhance(NoSearchResults);
